const states = [
  { name: "Abia" },
  { name: "Adamawa" },
  { name: "Akwa Ibom" },
  { name: "Anambra" },
  { name: "Bauchi" },
  { name: "Bayelsa" },
  { name: "Benue" },
  { name: "Borno" },
  { name: "Cross River" },
  { name: "Delta" },
  { name: "Ebonyi" },
  { name: "Enugu" },
  { name: "Edo" },
  { name: "Ekiti" },
  { name: "Gombe" },
  { name: "Imo" },
  { name: "Jigawa" },
  { name: "Kaduna" },
  { name: "Kano" },
  { name: "Katsina" },
  { name: "Kebbi" },
  { name: "Kogi" },
  { name: "Kwara" },
  { name: "Lagos" },
  { name: "Nasarawa" },
  { name: "Niger" },
  { name: "Ogun" },
  { name: "Ondo" },
  { name: "Osun" },
  { name: "Oyo" },
  { name: "Plateau" },
  { name: "Rivers" },
  { name: "Sokoto" },
  { name: "Taraba" },
  { name: "Yobe" },
  { name: "Zamfara" }
];

const subjects_sciences = [
  { name: "Mathematics" },
  { name: "English Language" },
  { name: "Physics" },
  { name: "Chemistry" },
  { name: "Biology" },
  { name: "Agricultural Science" },
  { name: "Civic Education" },
  { name: "Further Mathematics" },
  { name: "Technical Drawing" },
  { name: "Economics" },
  { name: "Yoruba" },
  { name: "Igbo" },
  { name: "Hausa" },
  { name: "Other (Trade subject)" }
];

const subjects_arts = [
  { name: "Mathematics" },
  { name: "English Language" },
  { name: "Literature in English" },
  { name: "History" },
  { name: "Commerce" },
  { name: "Agricultural Science" },
  { name: "Civic Education" },
  { name: "Christian Religious Studies" },
  { name: "Islamic Religious Studies" },
  { name: "Biology" },
  { name: "Yoruba" },
  { name: "Igbo" },
  { name: "Hausa" },
  { name: "Other (Trade subject)" }
];

const subjects_commercial = [
  { name: "Mathematics" },
  { name: "English Language" },
  { name: "Civic Education" },
  { name: "Economics" },
  { name: "Accounting" },
  { name: "Agricultural Science" },
  { name: "Biology" },
  { name: "Geography" },
  { name: "Government" },
  { name: "Yoruba" },
  { name: "Igbo" },
  { name: "Hausa" },
  { name: "Other (Trade subject)" }
];

const subjects_all = [
  { name: "Mathematics" },
  { name: "English Language" },
  { name: "Physics" },
  { name: "Chemistry" },
  { name: "Biology" },
  { name: "Agricultural Science" },
  { name: "Literature in English" },
  { name: "History" },
  { name: "Commerce" },
  { name: "Civic Education" },
  { name: "Further Mathematics" },
  { name: "Technical Drawing" },
  { name: "Civic Education" },
  { name: "Economics" },
  { name: "Accounting" },
  { name: "Agricultural Science" },
  { name: "Biology" },
  { name: "Geography" },
  { name: "Government" },
  { name: "Yoruba" },
  { name: "Igbo" },
  { name: "Hausa" },
  { name: "Other (Trade subject)" }
];

const Grade = [
  { name: "A1" },
  { name: "B2" },
  { name: "B3" },
  { name: "C4" },
  { name: "C5" },
  { name: "C6" },
  { name: "D7" },
  { name: "E8" },
  { name: "F9" }
]

export {
  states,
  subjects_sciences,
  subjects_arts,
  subjects_commercial,
  subjects_all,
  Grade
};
